import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CemenView.scss';
import CemenSearch from '../../Panels/CemenSearch/CemenSearch';
import BasePanel from '../../Panels/BasePanel';

class InvestView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <div>
          <BasePanel fullWidth user={this.props.user} style={{textAlign: "center"}} panelType="primary" panelTitle="Szukaj nagrobku">
            <CemenSearch prefix={this.props.district.prefix} />
          </BasePanel>
      </div>
    );
  }
}

InvestView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(InvestView);



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/CemenView/CemenView.js